import { v4 as uuid } from 'uuid'
/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  return async function onSubmit({ args, value, change }) {
    switch (args.type) {
      case 'create':
        return props.onCreate()
      case 'update':
        return props.onUpdate()
      case 'cancel':
        return props.onCancel()
      case 'addAction': {
        change(next => {
          let actions = Array.isArray(next.actions) ? [...next.actions] : []
          let insertIndex =
            typeof args.index === 'number' ? args.index : actions.length

          if (insertIndex < 0) insertIndex = 0
          if (insertIndex > actions.length) insertIndex = actions.length

          actions.splice(insertIndex + 1, 0, {
            id: uuid(),
            type: null,
            data: null,
            order: insertIndex + 1,
          })

          next.actions = actions.map((action, order) => ({
            ...action,
            order,
          }))
        })
        break
      }
      case 'addActionInWait': {
        change(next => {
          let actions = Array.isArray(next.actions) ? [...next.actions] : []
          if (!actions.length) return

          let startIndex = args.index

          if (startIndex < 0) startIndex = 0
          if (startIndex > actions.length - 1) startIndex = actions.length - 1

          let endIndex = startIndex + 1
          for (let i = startIndex + 1; i < actions.length; i++) {
            if (actions[i]?.type === 'wait') break
            endIndex = i + 1
          }

          actions.splice(endIndex, 0, {
            id: uuid(),
            type: null,
            data: null,
            order: endIndex,
          })

          next.actions = actions.map((action, order) => ({
            ...action,
            order,
          }))
        })
        break
      }
      case 'addActionWait': {
        change(next => {
          next.actions.push(
            {
              id: uuid(),
              type: 'wait',
              data: {
                weeks: 0,
                days: 0,
                hours: 0,
                minutes: 0,
                type: 'after',
                event: 'automation_triggered',
              },
              order: value.actions.length,
            },
            {
              id: uuid(),
              type: null,
              data: null,
              order: value.actions.length + 1,
            }
          )
        })
        break
      }
      case 'removeAction': {
        change(next => {
          let actions = [...value.actions]
          let target = actions[args.index]

          if (target?.type === 'wait') {
            let endIndex = args.index

            for (let i = args.index + 1; i < actions.length; i++) {
              if (actions[i]?.type === 'wait') break
              endIndex = i
            }

            actions.splice(args.index, endIndex - args.index + 1)
          } else {
            actions.splice(args.index, 1)
          }

          next.actions = actions
        })
        break
      }
      default:
        return
    }
  }
}
